import styled from "styled-components/macro";

export const CreatorsPageWrapperStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .header-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .header-side-content {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    button {
      padding: 0 14px;
    }

    .title {
      color: var(--Neutral-100);
      font-size: 24px;
      font-weight: 600;
      line-height: 32px;
      letter-spacing: -0.048px;
      padding: 4px;
    }

    .buttons-wrapper {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
`;

export const TableWrapperStyles = styled.div`
  .filter-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;

    .search-dropdown-styles {
      display: flex;

      .search-select {
        border-radius: 24px 0 0 24px;

        input {
          padding: 8px;
        }
      }
    }

    .filter-bar-menus {
      display: flex;
      flex-direction: row;
      gap: 8px;

      /* filters dropdown menu */
      .state-width {
        min-width: 150px;
      }

      .company-width {
        min-width: 180px;
      }

      .city-width {
        min-width: 140px;
      }

      .managed-by-width {
        min-width: 180px;
      }
    }
  }

  .creators-table {
    height: calc(100vh - 276px) !important;
    margin-bottom: 8px;
  }
`;
